<script>
// import Home from "@/components/Home.vue";

export default {
  components: {},
  data() {
    return {
      // 表格
      className: "",
      newName: {
        user: "",
        region: "",
      },
    };
  },

  methods: {
    //push
    linkStep1() {
      this.$router.push("/users/step1");
    },
    linkStep3() {
      this.$router.push("/users/step3");
    },
    linkStep4() {
      this.$router.push("/users/step4");
    },
    linkStep5() {
      this.$router.push("/users/step5");
    },
    linkStep6() {
      this.$router.push("/users/step6");
    },
    linkStep7() {
      this.$router.push("/users/step7");
    },
    linkPage4() {
      this.$router.push("/page4");
    },
  },
};
</script>

<template>
  <div id="index" class="animate__animated animate__fadeInDown">
    <!-- Jumbotron -->
    <header class="d-flex justify-content-center align-items-center">
      <div class="text-center">
        <div class="card alpha-50">
          <div class="card-body">
            <el-steps :active="0" simple>
              <el-step
                @click="linkStep1"
                title="網路掛號"
                icon="el-icon-s-custom"
              ></el-step>
              <el-step
                @click="linkStep3"
                title="至各診間候診"
                icon="el-icon-loading"
              ></el-step>
              <el-step
                @click="linkStep4"
                title="檢查、抽血"
                icon="el-icon-search"
              ></el-step>
              <el-step
                @click="linkStep5"
                title="櫃台批價"
                icon="el-icon-printer"
              ></el-step>
              <el-step
                @click="linkStep6"
                title="藥局領藥"
                icon="el-icon-sugar"
              ></el-step>
              <el-step
                @click="linkStep7"
                title="離院"
                icon="el-icon-school"
              ></el-step>
            </el-steps>
          </div>
        </div>
      </div>
    </header>

    <h1 class="pt-5 py-3">網路掛號</h1>
    <div>
      <h5 class="py-3">
        歡迎~<strong>{{ $store.state.name }}</strong> 請填入資訊並選擇看診方式
      </h5>
    </div>
    <!-- 輸入姓名 -->
    <el-form :inline="true" :model="newName" class="demo-form-inline">
      <el-form-item label="身分證 / 居留證號碼 / 病歷號碼：">
        <el-input v-model="newName.user" placeholder="輸入"></el-input>
      </el-form-item>
      <el-form-item label="看診方式：">
        <el-select v-model="newName.region" placeholder="請選擇">
          <el-option label="到院看診" value="123"></el-option>
          <el-option label="電話看診" value="456"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="linkPage4"
          >初診</el-button
        >
        <el-button type="primary" @click="linkStep3"
          >複診<i class="el-icon-s-claim el-icon--right"></i
        ></el-button>
      </el-form-item>
    </el-form>
    <!-- 輸入姓名 -->
  </div>
</template>

<style lang="scss" scoped>
#index {
  height: 700px;
  .alpha-50 {
    background: rgba(255, 255, 255, 0.5);
  }

  header {
    height: 300px;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)),
      url("https://cdn.pixabay.com/photo/2016/01/19/15/05/doctor-1149149_960_720.jpg")
        no-repeat center/cover;
  }
  h5 > strong {
    color: #0e6060;
  }
}
</style>
